import List from 'containers/Centres/List';
import Edit from 'containers/Centres/Edit';
import Create from 'containers/Centres/Create';
import Show from 'containers/Centres/Show';
import ResultFeaturedMarketing from 'containers/Centres/components/CentreTabs/MarketingTab/ResultFeaturedMarketing';

export default { List, Edit, Create, Show, ResultFeaturedMarketing };
